import React from 'react';
import styled from 'styled-components/macro';

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 70%;
  text-align: center;
`;

const Quote = styled.p`
  font-size: 1.1em;
  line-height: 1.6em;
  font-style: italic;
  font-weight: bold;
`;

const Source = styled.p`
  font-style: italic;
`;

const Slide = ({ source, children }) => {
  return (
    <Container>
      <Wrapper>
        <Quote>{children}</Quote>
        <Source>&ndash; {source}</Source>
      </Wrapper>
    </Container>
  );
};

export default Slide;
